import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TargetGroupFilter } from '../../target-group-filters/target-group-filter.interface';
import { TargetGroupFilterService } from './target-group-filter.service';

const service = new TargetGroupFilterService();

export interface TargetGroupFilterState {}

const TargetGroupFilterStore: Module<TargetGroupFilterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getTargetGroupFilters(context, clusterId: number) {
         const response = await service.getTargetGroupFilters(clusterId);
         return response;
      },
      async postTargetGroupFilters(context, payload: { clusterId: number; targetGroupFilters: Array<TargetGroupFilter> }) {
         const { clusterId, targetGroupFilters } = payload;
         const response = await service.postTargetGroupFilters(clusterId, targetGroupFilters);
         return response;
      },
      async deleteTargetGroupFilterTeams(context, clusterId: number) {
         const response = await service.deleteTargetGroupFilterTeams(clusterId);
         return response;
      },
   },
};

export default TargetGroupFilterStore;
